import {
  AutoAssignConfigContext,
  WidgetFormSubmissionWithWidget
} from "@closerplatform/spinner-openapi";
import { staticConfig } from "@fidget/common/config/static-config";
import { logger } from "@fidget/common/utils";
import { isEmpty } from "lodash";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useForeContext } from "../../../../models";
import { InputButton } from "../components/radioButtonsInput/inputButton";
import styles from "../components/styles.css";
import { findLast, takeRight } from "lodash";
import { ChatItemGroup } from "@fidget/common/models/chat/chatItemGroup";
import { MessageWithFormChatItem } from "@fidget/common/models/chat/chatItems";

interface Props {
  submission: WidgetFormSubmissionWithWidget;
  submissionConfig: AutoAssignConfigContext;
  messageId: string;
  scrollToBottom?(): void;
}
export const MessageWidgetAutoAssignForm = observer(
  ({ submission, submissionConfig, messageId, scrollToBottom }: Props) => {
    const { spinnerService, state } = useForeContext();

    const shouldDisableInputButtons = (): boolean => {
      const history = state.room.chat.history;

      const lastGroupChatItem = findLast(
        takeRight(history, staticConfig.widgetPageSize),
        (chatItem) => ChatItemGroup.isChatItemGroup(chatItem)
      );

      if (!lastGroupChatItem) {
        return true;
      }

      if (!ChatItemGroup.isChatItemGroup(lastGroupChatItem)) {
        return true;
      }

      const lastFormChatItem = findLast(lastGroupChatItem.items, (chatItem) =>
        MessageWithFormChatItem.isMessageWithFormChatItem(chatItem)
      );

      if (!lastFormChatItem) {
        return true;
      }

      if (lastFormChatItem.id !== messageId) {
        return true;
      }

      return !state.room.chat.isUserInputBlocked();
    };
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onClick = async (tagGroupId: string) => {
      if (isSubmitting) {
        return;
      }
      try {
        if (scrollToBottom) {
          scrollToBottom();
        }

        setIsSubmitting(true);

        const updated = await spinnerService.submitWidgetForm(submission.id, [
          { inputName: staticConfig.autoAssignFormInputName, value: tagGroupId }
        ]);

        state.room.chat.setSubmission(messageId, { ...submission, ...updated });
      } catch (e) {
        logger.error({ message: "Couldn't submit auto assign form", error: e });
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <div className={styles.options}>
        {submissionConfig.tagGroups.map(({ tagGroupId, displayName }) => (
          <InputButton
            disabled={
              !isEmpty(submission.userInputs) || isSubmitting || shouldDisableInputButtons()
            }
            key={tagGroupId}
            onClick={() => onClick(tagGroupId)}
          >
            {displayName}
          </InputButton>
        ))}
      </div>
    );
  }
);
